import { NgClass, NgStyle } from '@angular/common';
import { Component, effect } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonCard, IonIcon, IonText } from '@ionic/angular/standalone';
import { VxCurrencyPipe } from '@libs/core/lib/pipes/mtjr-currency.pipe';
import { HeartButtonComponent } from '@libs/mtjr/shared/products/heart_button.component';
import { VxProductCardComponent } from '@libs/mtjr/shared/products/product_card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mtjr-voucher-card',
  imports: [
    IonCard,
    IonIcon,
    IonText,
    HeartButtonComponent,
    VxCurrencyPipe,
    NgStyle,
    RouterLink,
    NgClass,
    TranslatePipe,
  ],
  template: `
    <ion-card
      class="!m-0 !h-full flex"
      [routerLink]="[
        isVendorOwner ? '/main/vendors' : '/landing/vendors',
        this.product().vendorId,
        'products',
        this.product().id,
      ]"
      [ngStyle]="{ background: this.product().bgColor }"
    >
      <div class="relative">
        @if (!isVendorOwner) {
          <mtjr-heart-button class="absolute end-0 top-0 z-50" cssClass="text-white" [productId]="product().id" />
        }
        <div
          class="absolute -end-10 top-0 h-40 w-40 bg-white/10"
          [ngClass]="{
            '[border-radius:60%_40%_30%_70%_/_50%_60%_30%_80%]': randomNum < 0.3,
            '[border-radius:80%_40%_50%_70%_/_50%_60%_40%_60%]': randomNum > 0.3 && randomNum < 0.6,
            '[border-radius:50%_40%_30%_70%_/_50%_60%_30%_80%]': randomNum > 0.6,
          }"
        ></div>
        <div
          class="absolute -end-14 top-0 h-40 w-40 bg-white/10"
          [ngClass]="{
            '[border-radius:80%_40%_50%_70%_/_50%_60%_40%_60%]': randomNum > 0.3,
            '[border-radius:70%_40%_50%_60%_/_50%_60%_40%_60%]': randomNum > 0.3 && randomNum < 0.6,
            '[border-radius:50%_40%_30%_70%_/_50%_60%_30%_80%]': randomNum < 0.3,
          }"
        ></div>
      </div>

      <div class="flex h-full items-center py-1.5">
        <div class="mx-1.5 h-full rounded-xl bg-white/10 p-1">
          <div
            class="aspect-square h-full bg-white"
            [ngStyle]="{
              mask: 'url(' + product().images?.[0] + ') no-repeat center / contain',
              '-webkit-mask': 'url(' + product().images?.[0] + ') no-repeat center / contain',
            }"
          ></div>
        </div>
        <div class="flex flex-col px-4">
          <div class="flex items-center">
            <ion-text color="dark" class="me-2 line-clamp-1 text-lg text-white">
              {{ product().name }}
            </ion-text>
            @if (isVendorOwner) {
              @switch (product().publishStatus) {
                @case ('published') {
                  <ion-icon
                    color="success"
                    name="checkmark-circle-outline"
                    size="small"
                    title="{{ 'PRODUCTS.PUBLISH_STATUS.PUBLISHED' | translate }}"
                  />
                }
                @case ('waitingForReview') {
                  <ion-icon
                    color="warning"
                    name="information-circle-outline"
                    size="small"
                    title="{{ 'PRODUCTS.PUBLISH_STATUS.WAITING_FOR_REVIEW' | translate }}"
                  />
                }
                @case ('rejected') {
                  <ion-icon
                    color="danger"
                    name="information-circle-outline"
                    size="small"
                    title="{{ 'PRODUCTS.PUBLISH_STATUS.REJECTED' | translate }}"
                  />
                }
                @case ('unPublished') {
                  <ion-icon
                    color="danger"
                    name="close-circle-outline"
                    size="small"
                    title="{{ 'PRODUCTS.PUBLISH_STATUS.UNPUBLISHED' | translate }}"
                  />
                }
                @case ('draft') {
                  <ion-icon
                    color="medium"
                    name="information-circle-outline"
                    size="small"
                    title="{{ 'PRODUCTS.PUBLISH_STATUS.DRAFT' | translate }}"
                  />
                }
              }
            }
          </div>
          <div class="mt-1 flex flex-wrap items-center">
            @if (priceRange(); as range) {
              <ion-text class="text-white">
                @if (range.min === range.max) {
                  {{ range.max | vxCurrency }}
                } @else {
                  <span class="hidden [html[lang='ar']_&]:block">
                    {{ range.min | vxCurrency: true }} - {{ range.max | vxCurrency }}
                  </span>
                  <span class="hidden [html[lang='en']_&]:block">
                    {{ range.min | vxCurrency }} - {{ range.max | vxCurrency: true }}
                  </span>
                }
              </ion-text>
            } @else {
              <ion-text class="text-md me-2 break-keep font-bold text-white">
                {{ product().price | vxCurrency }}
              </ion-text>
              @if (product().discount) {
                <ion-text class="break-keep text-sm text-white line-through">
                  {{ product().discount | vxCurrency }}
                </ion-text>
              }
            }
          </div>
        </div>
      </div>
    </ion-card>
  `,
})
export class VxVoucherCardComponent extends VxProductCardComponent {
  randomNum = Math.random();
  constructor() {
    super();
    effect(() => {
      console.log(this.product());
    });
  }
}
